import { typeCreatorV2 } from '../../../redux/utils/common';

export const SET_DOCUMENT_DETAIL: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetDocumentDetail'
);

export const SET_DOCUMENT_SECTION_BY_DOC_ID: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetDocumentSectionByDocId'
);

export const SET_DOCUMENT_PROPERTIES_BY_DOC_ID: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetDocumentPropertiesByDocId'
);
export const SET_PROPERTY_BY_SECTION_ID: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetPropertyBySectionId'
);

export const SET_NODE_PATH_CURRENT: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetNodePathCurrent'
);

export const SET_ADD_SECTION: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetAddSection'
);

export const SET_SECTION_DETAIL: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetSectionDetail'
);

export const SET_EDIT_SECTION: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetEditSection'
);

export const SET_UPDATE_FULL_SECTION: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetUpdateFullSection'
);

export const SET_DELETE_SECTION: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetDeleteSection'
);

export const SET_PROPERTY_NAME: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetPropertyName'
);

export const SET_ADD_PROPERTY: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetAddProperty'
);

export const SET_EDIT_PROPERTY: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetEditProperty'
);

export const SET_REORDER_PROPERTY: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetReorderProperty'
);

export const SET_DELETE_PROPERTY: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetDeleteProperty'
);

export const SET_TREE_DATA: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetTreeData'
);

export const SET_CUSTOMERS: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetCustomers'
);

export const ASSIGN_CUSTOMERS: string = typeCreatorV2(
  'DocumentEditReducer',
  'AssignCustomersToProposal'
);

export const SET_EXPORT_DOCX: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetExportDocx'
);

export const SET_LIST_TAGS: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetListTags'
);

export const SET_LIST_TAGS_WITH_SECTION: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetListTagsWithSection'
);

export const SET_CLONE_DOCX: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetCloneDocx'
);

export const SET_CLONE_SECTION: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetCloneSection'
);

export const SET_SECTION_COMMENTS: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetSectionComments'
);

export const INSERT_SECTION_COMMENT: string = typeCreatorV2(
  'DocumentEditReducer',
  'InsertSectionComment'
);

export const SET_LIST_DROPDOWNS: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetListDropDowns'
);

export const SET_ADD_DROPDOWN: string = typeCreatorV2(
  'DocumentEditReducer',
  'SetAddDropDown'
);
